import React from "react";
import "./styles/ChatConnectionError.scss";

const ChatConnectionError = ({ onRetry }) => {
  return (
    <div className="chatConnectionError">
      <div className="chatConnectionError__box">
        <p className="chatConnectionError__title">
          チャットサーバーに接続できませんでした
        </p>
        <p className="chatConnectionError__description">
          ネットワーク接続を確認してから、再試行してください。
        </p>
        <button
          type="button"
          className="chatConnectionError__retryButton"
          onClick={onRetry}
        >
          再試行
        </button>
      </div>
    </div>
  );
};

export default ChatConnectionError;
